import { Chip } from '@otp/ui';
import { Maybe, WttpQuestionCategory } from 'src/graphql/generated/graphql';

export const CategoryField = ({
  category,
}: {
  category?: WttpQuestionCategory | Maybe<WttpQuestionCategory>;
}) => {
  return <Chip label={category?.name} color="primary" size="small" />;
};
